// Global CSS classes
enum GlobalClass {
  ButtonPlain = "buttonPlain",
  HideText = "hideText",
}

export default GlobalClass;
